import { useEffect, useState } from "react";
import { get_formated_time } from "../../../command_center/utils";
import { useDispatch, useSelector } from "react-redux";
import UnifiedControlPlaneService from "../../UnifiedControlPlane.service";
import { resetScenarioData, setShowConfirmationModal } from "../../../../store/UnifiedControlPlaneSlice";
import ScenarioConfirmationModal from "../Scenario/ScenarioConfirmationModal";
import { buildStyles, CircularProgressbarWithChildren } from "react-circular-progressbar";
import RadialSeparators from "../../../CommonComponents/circular_progress/RadialSeparators";
import { calculateProgressTime, calculateTimePercentage, getTimeUTCWithNoMs } from "../Utils/HelperFunctions";




const BottomBarOrderAnalytics = ({ props }) => {
  const dispatch = useDispatch();
  const [newCurrentScenarioTime, setNewCurrentScenarioTime] = useState(null); //cesium new current scenario time
  const [liveTime, setLiveTime] = useState(getTimeUTCWithNoMs(new Date()));
  const showMapBoxMap = useSelector(state => state.unifiedControlPlane.showMapBoxMap);
  const orbitApiCalled = useSelector(state => state.unifiedControlPlane.orbitApiCalled);
  const scenarioMultiplier = useSelector(state => state.unifiedControlPlane.scenarioMultiplier);
  const selectedScenario = useSelector(state => state.unifiedControlPlane.selectedScenario);
  const scenarioCurrentTime = useSelector(state => state.unifiedControlPlane.scenarioCurrentTime);
  const showConfirmationModal = useSelector(state => state.unifiedControlPlane.showConfirmationModal)

  const simulationEndTime = selectedScenario?.scenarioStartTime && selectedScenario?.simulationDuration ? selectedScenario?.scenarioStartTime + selectedScenario?.simulationDuration * 60 : null;

  useEffect(() => {
    const interval = setInterval(() => {
      setLiveTime(getTimeUTCWithNoMs(new Date())); // Update time every second
    }, 1000);

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  useEffect(() => {
    if (!scenarioCurrentTime) return;

    // Parse the initial scenario time
    const startTime = new Date(scenarioCurrentTime).getTime();
    setNewCurrentScenarioTime(startTime);

    const interval = setInterval(() => {
      setNewCurrentScenarioTime(prevTime => {
        if (!prevTime) return prevTime;
        const multiplier = scenarioMultiplier || 1.0;
        return prevTime + (multiplier * 1000); // Add seconds in milliseconds
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [scenarioCurrentTime, scenarioMultiplier]);


  const onScenarioDisconnect = () => {
    dispatch(resetScenarioData())
  }

  const DisconnectScnenario = () => {
    if (!selectedScenario?.missionId) return;
    dispatch(UnifiedControlPlaneService.disconnectScenario(selectedScenario?.missionId, selectedScenario?.scenarioName, onScenarioDisconnect));
  }

  const handleDisconnectScenario = () => {
    dispatch(setShowConfirmationModal(true))
  }

  const handleModalConfirm = () => {
    dispatch(setShowConfirmationModal(false));
    DisconnectScnenario();
  }

  const handleModalCancel = () => {
    dispatch(setShowConfirmationModal(false));
  }

  const showScenarioTimer = () => {
    return ((selectedScenario?.status === "SimulationRunning" && newCurrentScenarioTime > 0 && simulationEndTime > 0 && !showMapBoxMap && orbitApiCalled) || (selectedScenario?.status === "SimulationCompleted" && simulationEndTime > 0));
  }

  const getScenarioProgressValue = () => {
    return selectedScenario?.status === "SimulationCompleted" ? simulationEndTime : newCurrentScenarioTime / 1000;
  }

  const getScenarioProgressText = () => {
    return selectedScenario?.status === "SimulationCompleted" ? "100%" :
      `${calculateTimePercentage(selectedScenario?.simulationStartTime, simulationEndTime, newCurrentScenarioTime / 1000)}%`;
  }

  const getScenarioProgressTime = () => {
    return selectedScenario?.status === "SimulationCompleted"
      ? "00:00:00"
      : calculateProgressTime(selectedScenario?.scenarioStartTime, newCurrentScenarioTime / 1000)
  }

  const getScenarioCurrentTime = () => {
    return selectedScenario?.status === "SimulationCompleted"
      ? get_formated_time(simulationEndTime)
      : get_formated_time(newCurrentScenarioTime / 1000)
  }

  return (
    <>
      <div className="bottomBlackBarComponent">
        <div className="bottomBarCurrentTime">
          {liveTime}
        </div>
        <div className="bottomBarOrderAnalytics">
          <button
            className={props.bottomBarComponent.Order ? "bottomBarOrderAnalyticsComponent active" : "bottomBarOrderAnalyticsComponent"}
            onClick={() => props.setBottomBarComponent({ Order: true, Analytics: false, Policy: false })}
          >
            <img src={require("../../assets/raw/OrderIcon.svg").default} alt=""></img>
            Orders
          </button>
        </div>
        {selectedScenario && Object.keys(selectedScenario).length > 0 ?
          (
            <div className="bottomBarActions">
              {showScenarioTimer() && (
                <div className="bb-scenario-time-container">
                  <div className="bb-circular-timer-container">
                    <div className="progress-circle">
                      <CircularProgressbarWithChildren
                        value={getScenarioProgressValue()}
                        minValue={selectedScenario.simulationStartTime}
                        maxValue={simulationEndTime}
                        text={getScenarioProgressText()}
                        strokeWidth={15}
                        styles={buildStyles({
                          strokeLinecap: "butt",
                          pathTransitionDuration: 0.5,
                          textColor: "#FFF",
                          pathTransition: "none",
                          trailColor: "rgba(240, 240, 240, 0.2)",
                          pathColor: "#F2A93B",
                        })}
                      >
                        <RadialSeparators
                          count={25}
                          style={{
                            background: "#000",
                            width: "2px",
                            height: `${15}%`,
                          }}
                        />
                      </CircularProgressbarWithChildren>
                    </div>
                    <div className="progress-time">
                      {getScenarioProgressTime()}
                    </div>
                  </div>
                  <div className="bb-scenario-progress-time">
                    <div className="scenario-progress-time scenario-current-time">
                      {getScenarioCurrentTime()}
                    </div>
                    <div className="scenario-progress-time scenario-end-time">
                      {get_formated_time(simulationEndTime)}
                    </div>
                  </div>
                </div>
              )}
              {selectedScenario?.status !== "SimulationCompleted" && (
                <div className="bottomBarActionBtn" onClick={handleDisconnectScenario}>
                  <div className="btn-text">Disconnect</div>
                </div>
              )}
            </div>
          ) : null
        }
      </div>
      {showConfirmationModal && <ScenarioConfirmationModal onConfirm={handleModalConfirm} onCancel={handleModalCancel} />}
    </>
  );
};

export default BottomBarOrderAnalytics;
